<template>
    <div>
        <div style="display: flex; flex: 1; justify-content: flex-end;">
            <v-checkbox
                v-model="showDateWithEmptyData"
                color="secondary lighten-1"
                label="Mostrar datas com dados ausentes"
            ></v-checkbox>
        </div>
        <div class="mb-12" v-for="(hourlyTable, indexTable) in hourlyTables" :key="`hourlytable${indexTable}`">
            <div class="pb-3 primary darken-1">
                <v-icon class="mr-2" color="secondary lighten-1" size="20">{{mapIconBySensorId(hourlyTable.sensor.codigo)}}</v-icon>
                <strong style="font-size: 16px;line-height: 20px;">{{hourlyTable.sensor.descricao}}</strong>
            </div>
            <hourly-table-data-by-sensor
                :headers="hourlyTable.headers"
                :highlightsCards="verifyHighlights(highlightsCards)"
                :hourColumnKeys="hourlyTable.hourColumnKeys"
                :items="hourlyTable.items"
                :showDateWithEmptyData="showDateWithEmptyData"
            >
            </hourly-table-data-by-sensor>
        </div>

        <hourly-table-data-to-export
            ref="hourlyTableDataToExport"
            :highlightsCards="highlightsCards"
            :searchResult="searchResult"
            :dataPeriodDate="dataPeriodDate"
            :exportFileName="exportFileName"
        >
        </hourly-table-data-to-export>
    </div>
</template>
<script>
import moment from "moment";
import HourlyTableDataBySensor from "./HourlyTableDataBySensor.vue";
import HourlyTableDataToExport from "./TableToExportPDF/HourlyTableDataToExport.vue";
import writeXlsxFile from 'write-excel-file';
export default {
    name: "HourlyTableData",
    props: {
        searchResult:{
            type: Object,
        },
        highlightsCards:{
            type: Array,
        },
        dataPeriodDate:{
            type: Array
        }
    },
    components:{
        HourlyTableDataBySensor,
        HourlyTableDataToExport,
    },
    data:()=>({
        showDateWithEmptyData: true,
        itemsPerPage: 10,
        page: 1,
        pageCount: undefined,
        headers: [],
        items:[],
        hourColumnKeys: [],
        hourlyTables: [],
        exportFileName: undefined,
        tablesWidth: "",
    }),

    created(){
        this.initialize();
    },

    watch:{
        itemsPerPage(value){
            if(value){
                this.page = 1;
            }
        },

        searchResult(value){
            if(value){
                this.initialize();
            }
        }
    },

    methods:{
        initialize(){
            const { sensors, resultList } = this.searchResult;
            this.hourlyTables = [];
            for (const sensor of sensors) {
                const hourColumnKeys = this.generateColumsKeys(resultList, sensor.codigo);
                const headers = this.generateHeaders(hourColumnKeys);
                const generatedItems = this.generateHourlyItems(resultList, sensor.codigo);
                const items = this.groupItemsByDate(generatedItems);
                this.hourlyTables.push({ hourColumnKeys, headers, items, sensor });
            }
            this.exportFileName = this.generateExportFileName(this.searchResult);
        },

        generateColumsKeys(resultList, sensorId){
            const resultsBySensorId = resultList.filter((result) => result.sensorId === sensorId);
            const keys = [];
            for (const result of resultsBySensorId) {
                const { datahora } = result;
                const hourKey = moment(datahora).tz("America/Sao_Paulo").format("HH");
                if(keys.indexOf(hourKey) === -1) keys.push(hourKey);
            }
            const sortedKeys = this.sortColumnsKeys(keys);
            return sortedKeys.map(key => key.toString().padStart(2, "0"))
        },

        sortColumnsKeys(keys){
            const keysNumbers = keys.map(key => Number(key));
            return keysNumbers.sort((a, b) => a - b);
        },

        generateHeaders(hourColumnKeys){
            const headers = []
            const dateHeader = {
                text: "",//type === "diario" ? "Dia" : type === "mensal" ? "Mês" : " Hora",
                align: 'start',
                sortable: false,
                value: 'date',
                width: 80,
            };
            headers.push(dateHeader);
            for (const hourKey of hourColumnKeys) {
                headers.push({
                    text: hourKey,
                    align: 'center',
                    sortable: true,
                    value: `hour${hourKey}Value`,
                    width: 100,
                });
            }
            return headers;
        },

        generateHourlyItems(resultList, sensorId){
            const resultsBySensorId = resultList.filter((result) => result.sensorId === sensorId);
            const items = [];
            for (const result of resultsBySensorId) {
                const { datahora } = result;

                items.push({
                    date: moment(datahora).tz("America/Sao_Paulo").format("DD/MM/YYYY"),
                    dateIso: datahora,
                    value:  result.valor,
                    sensorId: result.sensorId,
                    tag: result.tag,
                })
            }
            return items;
        },

        groupItemsByDate(items){
            const groupItems = [];
            const dateKeys = [];
            for (const item of items) {
                const { date } = item;
                if(dateKeys.indexOf(date) === -1) dateKeys.push(date);
            }
            for (const dateKey of dateKeys) {
                let groupItem = { date: dateKey };
                const resultsByDate = items.filter((item) => item.date === dateKey);
                for (const result of resultsByDate) {
                    const { value, sensorId, dateIso } = result; 
                    const hourKey = moment(dateIso).tz("America/Sao_Paulo").format("HH");
                    groupItem.dateIso = moment(dateIso).tz("America/Sao_Paulo").format("YYYY-MM-DD");
                    groupItem[`hour${hourKey}Value`] = value;
                    groupItem[`hour${hourKey}Id`] = sensorId;
                }
                groupItems.push(groupItem);
            }
            return groupItems;
        },

        mapIconBySensorId(code){
            if(code === 1 || code === 3 || code === 4 || code === 5){
                return 'icon-infohidro-termometro'
            } else if(code === 2){
                return 'mdi-water-alert-outline'
            } else if(code === 6){
                return 'mdi-sun-wireless'
            } else if(code === 7){
                return 'mdi-weather-pouring'
            } else if(code === 8 || code === 9 || code === 10){
                return 'mdi-weather-windy'
            } else if(code === 15){
                return 'mdi-gauge'
            } else if(code === 18){
                return 'mdi-arrow-expand-vertical'
            } else if(code === 33){
                return 'mdi-waves'
            } else {
                return 'icon-infohidro-volume'
            }
        },

        verifyHighlights(highlights){
            const sensors = [];
            for (const highlight of highlights) {
                const { sensorId } = highlight;
                if(sensors.indexOf(sensorId) === -1) sensors.push(sensorId)
            }
            const highlightsVerified = [];
            for (const sensor of sensors) {
                const verified = this.changeTheSameTag(highlights.filter((item) => item.sensorId === sensor));
                highlightsVerified.push(...verified);
            }
            return highlightsVerified;
        },

        changeTheSameTag(highlights){
            const min = highlights.find(item => item.tag === "min");
            const max = highlights.find(item => item.tag === "max");
            if(min && max && moment(min.datahora).isSame(moment(max.datahora), "hours")){
                return [{ ...max, tag: "same"}];
            }
            return highlights;
        },

        generatePDF(settings) {
            this.$refs.hourlyTableDataToExport.generatePDF(settings);
        },

        generateCSV(settings){
            let csvContent = "data:text/csv;charset=utf-8,";
            const mapItems = this.applySettings(settings,this.mapItemsToExport(this.searchResult.resultList));
            csvContent += [
                Object.keys(mapItems[0]).join(";"),
                ...mapItems.map(item => Object.values(item).join(";"))
            ]
                .join("\n")
                .replace(/(^\[)|(\]$)/gm, "");

            const data = encodeURI(csvContent);
            const link = document.createElement("a");
            link.setAttribute("href", data);
            link.setAttribute("download", `${this.exportFileName}.csv`);
            link.click();
        },

        async generateXLS(settings){
            const mapItems = this.applySettings(settings,this.mapItemsToExport(this.searchResult.resultList));
            const columns = Object.keys(mapItems[0]);
            const schema = columns.map((column) => ({ column, type: String, fontStyle: "normal", value: item => item[column] }));
            await writeXlsxFile(mapItems, {
                schema,
                fileName: `${this.exportFileName}.xlsx`,
                headerStyle: {
                    fontWeight: 'normal',
                    align: 'center'
                },
            });
        },

        mapItemsToExport(items){
            return this.groupItemsByDateToExport(items);
        },

        groupItemsByDateToExport(items){
            const groupItems = [];
            const dateKeys = [];
            for (const item of items) {
                const { datahora } = item;
                if(dateKeys.indexOf(datahora) === -1) dateKeys.push(datahora);
            }
            for (const dateKey of dateKeys) {
                let groupItem = { date: moment(dateKey).tz("America/Sao_Paulo").format("YYYY-MM-DDTHH:mm") };
                const resultsByDate = items.filter((item) => item.datahora === dateKey);
                for (const result of resultsByDate) {
                    const { valor, sensorId } = result; 
                    const sensorFind = this.searchResult.sensors.find(sensor =>sensor.codigo == sensorId);
                    groupItem[sensorFind.descricao] = valor || valor === 0 ? valor.toString() : "";
                }
                groupItems.push(groupItem);
            }
            return groupItems;
        },

        applySettings(settings, items){
            const {option, replaceData} = settings;
            if(option === "replace-data" && replaceData){
                return this.replaceEmptyValue(items, replaceData);
            }
            if(option === "remove-dates-with-empty-values"){
                return this.removeDatesWithEmptyValues(items);
            }
            return items;
        },

        replaceEmptyValue(items, replaceData){
            const itemsReplaced = [];
            for (const item of items) {
                const verifyItem = Object.assign({}, item);
                const keys = Object.keys(verifyItem);
                for (const key of keys) {
                    if(key === "date") continue;
                    if(verifyItem[key] !== 0 && !verifyItem[key]){
                        verifyItem[key] = replaceData;
                    }
                }
                itemsReplaced.push(verifyItem);
            }
            return itemsReplaced;
        },

        removeDatesWithEmptyValues(items){
            const itemsReplaced = [];
            for (const item of items) {
                const verifyItem = Object.assign({}, item);
                const verifyItemAsArray = Object.entries(verifyItem);
                const emptyDates = verifyItemAsArray.filter((entryItem) => {
                    const [ key, value ] = entryItem;
                    return key !== "date" && (value || value === 0)
                });
                if(emptyDates.length){
                    itemsReplaced.push(verifyItem);
                }
            }
            return itemsReplaced;
        },

        formatDate(date){
            const stringFormat = "DD/MM/YYYY HH:mm";
            return moment(date).tz("America/Sao_Paulo").locale("pt-br").format(stringFormat);
        },

        capitalize(text){
            return text[0].toUpperCase() + text.slice(1);
        },

        generateExportFileName(searchResult){
            const typeName = "sumario_horario";
            const stationName = searchResult.station.nome;
            const periodFormat = `${this.formatDate(searchResult.date_start)} até ${this.formatDate(searchResult.date_end)}`
            return `${stationName}-${typeName}-${periodFormat}`;
        }
    }
}
</script>

<style scoped>
    
</style>